export default {
  gemAPI: "http://great-edge/api/GEM/V2/",
  apiUrl: "https://greatwideapi.great-edge.net/",
  //apiUrl: "https://apipreview.great-edge.net/",
  mapquestApiKey: "Fmjtd|luuanuut20,rn=o5-96bldw",
  pushKey:
    "BHmR6yWY5uiTRoisNC4fkcMI-7ORhljE7hZgUprVXMCW4PUkP5_VfDJ2U9jmA6BJUc1Cw_O4GfRtO-D0JDrJ9oU",
};
